export const isTransactionAccount = (accountType) => accountType === 'TRANSACTION_INDIVIDUAL' || accountType === 'TRANSACTION_JOINT';
export const cashAccountDisplayName = (trxAccountType) => (trxAccountType === 'TRANSACTION_JOINT' ? 'Joint Cash Account' : 'Cash Account');
export const getPurchaseText = (from, to) => {
    if (!from || !to) {
        return 'Deposit';
    }
    const fromType = from.accountType;
    const toType = to.accountType;
    if (toType === 'DEPOSIT') {
        switch (fromType) {
            case 'CHECKING':
            case 'SAVINGS':
                return 'Deposit from External Account';
            case 'TRANSACTION_JOINT':
            case 'TRANSACTION_INDIVIDUAL':
                return `Deposit from ${cashAccountDisplayName(fromType)}`;
            case 'DEPOSIT':
                return `CD renewed from ${from.accountNumber}`;
        }
    }
    if (isTransactionAccount(toType)) {
        switch (fromType) {
            case 'CHECKING':
            case 'SAVINGS':
                return 'Transfer in from External Account';
            case 'TRANSACTION_JOINT':
            case 'TRANSACTION_INDIVIDUAL':
                return `Transfer from ${cashAccountDisplayName(fromType)}`;
            case 'DEPOSIT':
                return `Withdrawal from ${from.institutionName} (${from.accountNumber})`;
        }
    }
    return '';
};
export const getWithdrawalText = (from, to) => {
    if (!from || !to) {
        return 'Withdrawal';
    }
    const fromType = from.accountType;
    const toType = to.accountType;
    if (fromType === 'DEPOSIT') {
        switch (toType) {
            case 'CHECKING':
            case 'SAVINGS':
                return 'Transfer out to External Account';
            case 'TRANSACTION_JOINT':
            case 'TRANSACTION_INDIVIDUAL':
                return `Withdrawal to ${cashAccountDisplayName(toType)}`;
        }
    }
    if (isTransactionAccount(fromType)) {
        switch (toType) {
            case 'CHECKING':
            case 'SAVINGS':
                return 'Transfer out to External Account';
            case 'TRANSACTION_JOINT':
            case 'TRANSACTION_INDIVIDUAL': {
                return `Transfer to ${cashAccountDisplayName(toType)}`;
            }
            case 'DEPOSIT':
                return `Deposit to ${to.institutionName} (${to.accountNumber})`;
        }
    }
    return '';
};
export const getRollbackText = ({ depositStatus, to }) => {
    if (!to) {
        return 'CD Withdrawal';
    }
    let targetAccountName = 'Account';
    switch (to.accountType) {
        case 'TRANSACTION_INDIVIDUAL':
        case 'TRANSACTION_JOINT':
            targetAccountName = cashAccountDisplayName(to.accountType);
            break;
        case 'CHECKING':
        case 'SAVINGS':
            targetAccountName = 'External Account';
            break;
        default:
            targetAccountName = 'Account';
    }
    const baseText = `Withdrawal to ${targetAccountName}`;
    if (['AWAITING_CANCELLATION', 'CLOSED'].includes(depositStatus || '')) {
        return 'CD Cancelled - ' + baseText;
    }
    return baseText;
};
const transactionDescriptions = {
    PURCHASE: ({ from, to }) => getPurchaseText(from, to),
    WITHDRAWAL: ({ from, to }) => getWithdrawalText(from, to),
    ROLLOVER: () => 'CD matured and rolled over',
    ROLLBACK: ({ to, depositStatus }) => getRollbackText({ to, depositStatus }),
    INTEREST_PAYOUT: ({ to }) => {
        const toAcct = to?.accountType;
        if (toAcct === 'DEPOSIT') {
            return 'Interest rolled over';
        }
        return `Interest withdrawal to ${isTransactionAccount(toAcct) ? cashAccountDisplayName(toAcct) : 'External Account'}`;
    },
    FEE: () => 'Early withdrawal penalty',
    INTEREST_POSTING: () => 'Interest paid',
    ACH_RETURN: () => 'Funds returned through ACH Return'
};
export function getTransactionDescription({ from, to, type, depositStatus }) {
    return transactionDescriptions[type]({ from, to, depositStatus });
}
